const Auxiliary = (props) => props.children;

export default Auxiliary;



// WEBPACK FOOTER //
// ./src/util/Auxiliary.js